export default __webpack_public_path__ + "static/media/SEMBRANDO_mapa.8be72617.JPG";